import type { NotificationType } from '../../core/NotificationType';
import useRiskCardController from './hooks/useRiskCardController';
import useRiskToastController from './hooks/useRiskToastController';
import RiskRecognitionDrawer from './RiskDrawer';

/**
 * Registro do tipo `risk-recognition` — o primeiro tipo de notificação. Liga o contrato genérico
 * (surfaces, controllers, drawer) à implementação concreta do risco. A fonte de dados é a listagem da API
 * (AI-432); o feed do Knock saiu (AI-450), então não há mais `parse`/`workflowKeys` de feed item.
 */
export const riskRecognitionType: NotificationType = {
  key: 'risk-recognition',
  surfaces: { card: true, toast: true, drawer: true },
  useCardController: useRiskCardController,
  useToastController: useRiskToastController,
  Drawer: RiskRecognitionDrawer,
};
